'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findNextOpenDay = exports.isOpen = exports.getHoursMinutes = exports.getTimeNow = undefined;
var _date = require('@marmalade/date');
var _constants = require('./constants');

// Returns the time as a whole number - 9:45 = 9.75 / 14:30 = 14.5
var getTimeNow = exports.getTimeNow = function getTimeNow(date) {
  return date.getHours() + date.getMinutes() / 60;
};

// Return an object with hours, minutes for a whole number time - 19.5 = { hours: 19, minutes: 30 }
var getHoursMinutes = exports.getHoursMinutes = function getHoursMinutes(time) {
  var hours = Math.floor(time);
  var minutes = Math.round((time - hours) * 60);
  return {
    hours: hours,
    minutes: minutes
  };
};
var isOpen = exports.isOpen = function isOpen() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var day = (0, _date.getNamedDay)(date.getDay()).toLowerCase();
  if (_constants.openingHours[day] === 'closed') {
    return false;
  }
  var now = getTimeNow(date);
  return now >= _constants.openingHours[day].open && now < _constants.openingHours[day].close;
};
var findNextOpenDay = exports.findNextOpenDay = function findNextOpenDay() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var today = (0, _date.getNamedDay)(date.getDay()).toLowerCase();
  // If today's open hasn't happened yet.
  if (today !== 'closed' && getTimeNow(date) < _constants.openingHours[today].open) {
    return 'today';
  }
  // Else start from tomorrow
  var count = 0;
  var day = date.getDay() < 6 ? date.getDay() : 0;
  var nextOpen = void 0;
  while (typeof nextOpen === 'undefined' && count < 7) {
    var name = (0, _date.getNamedDay)(day);
    if (_constants.openingHours[name.toLowerCase()] !== 'closed') {
      nextOpen = name;
    } else {
      count++;
      day = day + 1 < 7 ? day + 1 : 0;
    }
  }
  if (typeof nextOpen !== 'undefined') {
    return count > 0 ? nextOpen : 'tomorrow';
  }
  return nextOpen;
};